// extracted by mini-css-extract-plugin
export default {"startMenuItem":"start-menu-icon_startMenuItem__hbZnm","startMenuItemIcon":"start-menu-icon_startMenuItemIcon__DqFVO","startMenuItemName":"start-menu-icon_startMenuItemName__oas3z"};